import { Box, BoxProps, Heading, VStack } from '@chakra-ui/react';
import { helpOptions } from 'components/OnboardingQuiz/atoms/OptionsData';
import React from 'react';
import HowCanWeHelpItem from './atoms/HowCanWeHelpItem';

interface QuestionHowCanWeHelpProps extends BoxProps {
  onOptionSelect: (value: string) => void;
}

const QuestionHowCanWeHelp = ({
  onOptionSelect,
  ...props
}: QuestionHowCanWeHelpProps) => {
  return (
    <Box {...props}>
      <Box marginBottom="37px">
        <Heading
          as="h3"
          fontFamily="Gelica"
          fontSize="30px"
          lineHeight="35px"
          fontWeight={400}
          color="neutral.700"
        >
          How can we help?
        </Heading>
      </Box>

      <Box>
        <VStack alignItems="flex-start" spacing="8px" marginBottom="18px">
          {helpOptions.map(({ text, value }) => {
            return (
              <HowCanWeHelpItem
                key={value}
                label={text}
                onClick={() => onOptionSelect(value)}
              />
            );
          })}
        </VStack>
      </Box>
    </Box>
  );
};

export default QuestionHowCanWeHelp;
